/**
 * Samples every feed layer into the in-browser history buffer on a fixed cadence
 * and keeps the timeline's available range up to date.
 */

import { useEffect } from 'react';
import type { Track } from '@vtak/shared';
import { usePluginDataStore } from '@/stores/plugin-data-store';
import { useTimelineStore } from '@/stores/timeline-store';
import { recordSample, earliestSample, clearBuffer } from '@/map/history/history-buffer';

/** Sampling cadence. */
const SAMPLE_MS = 5000;

/** Record feed-layer snapshots into the history buffer over time. */
export function useHistoryBuffer(): void {
  useEffect(() => {
    sampleNow();
    const id = setInterval(sampleNow, SAMPLE_MS);
    return () => {
      clearInterval(id);
      clearBuffer();
    };
  }, []);
}

/** Snapshot all current feed layers and update the timeline range. */
function sampleNow(): void {
  const now = Date.now();
  for (const [layer, tracks] of usePluginDataStore.getState().data) {
    recordSample(layer, (tracks as Track[]) ?? [], now);
  }
  useTimelineStore.getState().setRange(earliestSample(now), now);
}
